export default {
  organizations_title: 'License suspension',
  organizations_subtitle: 'Pick an organization to see its business units.',
  report_nav_button: 'License report',
  franchises_subtitle: 'Pick a business unit to see its users.',
  users_subtitle: 'Activate or suspend each user license.',

  column_logo: 'Logo',
  column_photo: 'Photo',
  column_id: 'ID',
  column_organization: 'Organization',
  column_franchise: 'Business unit',
  column_franchises_count: 'Business units',
  column_licenses: 'Licenses',
  column_active: 'Active',
  column_suspended: 'Suspended',
  column_status: 'Status',
  column_is_unused: 'Unused',
  column_actions: 'Actions',
  column_first_name: 'First name',
  column_last_name: 'Last name',
  column_email: 'Email',
  column_license: 'License',
  column_license_type: 'License type',
  column_assigned_at: 'Assigned date',

  status_active: 'Active',
  status_suspended: 'Suspended',
  is_unused_yes: 'Unused',
  is_unused_no: 'In use',
  organization_status_active: 'Active',
  organization_status_inactive: 'Inactive',
  organization_status_demo: 'Demo',

  filter_status: 'Status',
  filter_all_statuses: 'All statuses',

  no_organizations: 'No organizations match the search.',
  no_franchises: 'This organization has no business units.',
  no_users: 'No users match the current filters.',

  suspend_all: 'Suspend all',
  reactivate_all: 'Reactivate all',
  bulk_suspend: 'Suspend licenses',
  bulk_reactivate: 'Reactivate licenses',
  clear_selection: 'Clear selection',
  selected_count: 'Selected: {count}',
  selected_licenses: '{count} license(s) in the selected scope',
  scope_organizations: '{count} organizations',
  scope_franchises: '{count} business units',

  confirm_suspend_title: 'Suspend licenses',
  confirm_reactivate_title: 'Reactivate licenses',
  confirm_suspend_organization: 'You are about to suspend {count} license(s) from {scope}. '
    + 'This affects ALL of its users, across every business unit.',
  confirm_reactivate_organization: 'You are about to reactivate {count} license(s) from {scope}. '
    + 'This affects ALL of its users, across every business unit.',
  confirm_suspend_franchise: 'You are about to suspend {count} license(s) from {scope}. This affects ALL users in that business unit.',
  confirm_reactivate_franchise: 'You are about to reactivate {count} license(s) from {scope}. This affects ALL users in that business unit.',
  confirm_suspend_users: 'You are about to suspend {count} license(s) from {scope}.',
  confirm_reactivate_users: 'You are about to reactivate {count} license(s) from {scope}.',
  confirm_suspend_user: 'Do you want to suspend the license for {email}?',
  confirm_reactivate_user: 'Do you want to reactivate the license for {email}?',
  confirm_ok: 'Confirm',
  confirm_cancel: 'Cancel',

  reason_label: 'Reason',
  reason_detail_label: 'Detail (optional)',
  reason_detail_label_required: 'Detail',
  reason_detail_hint: 'Maximum 2000 characters',

  reason_invoice_overdue: 'Overdue invoice',
  reason_contract_termination: 'Contract termination',
  reason_trial: 'Trial period ended',
  reason_temporary_reactivation: 'Temporary reactivation',
  reason_payment_success: 'Payment received',
  reason_other: 'Other',

  notify_suspended: 'License suspended',
  notify_reactivated: 'License reactivated',
  notify_bulk_suspended: '{count} license(s) suspended',
  notify_bulk_reactivated: '{count} license(s) reactivated',
  notify_no_changes: 'No changes: those licenses were already in that state',
  notify_load_error: 'The information could not be loaded',
  notify_error: 'The license could not be updated',
  error_reason_invalid: 'The selected reason does not match this action. Try again.',

  report_title: 'License report',
  report_subtitle: 'Generate a license export filtered by organization, business unit, type and assignment date.',
  report_filter_organization: 'Organization',
  report_filter_franchise: 'Business unit',
  report_filter_franchise_all: 'All business units',
  report_filter_type: 'License type',
  report_filter_type_all: 'All types',
  report_filter_type_individual: 'Individual',
  report_filter_type_franchise: 'Franchise',
  report_filter_assigned_from: 'Assigned from',
  report_filter_assigned_to: 'Assigned to',
  report_download: 'Download report',
  report_download_pdf: 'Download PDF',
  report_export_starting: 'The export has started. We will let you know in the notifications panel when it is ready.',
  report_export_error: 'Error requesting the export. Please try again.',
  report_preview_title: 'Preview',
  report_preview_hint: 'Select an organization to preview the licenses.',

  kpi_dashboard_title: 'Summary',
  kpi_total: 'Total licenses',
  kpi_active: 'Active',
  kpi_active_percent: '{percent}% active',
  kpi_suspended: 'Suspended',
  kpi_subutilized: 'Unused',
  kpi_subutilized_tooltip: 'No connection for {days}+ days',
  kpi_demo: 'Demo',
  kpi_demo_usage: '{used} / {quota}',
  kpi_demo_no_quota: 'No demo quota configured',
  kpi_demo_percent: '{percent}% used',
  kpi_standard: 'Standard',
  kpi_chart_title: 'License composition',
  kpi_chart_active: 'Active',
  kpi_chart_suspended: 'Suspended',
  kpi_chart_subutilized: 'Unused',

  global_kpi_title: 'Platform totals',
  global_kpi_sync: 'Sync',
  global_kpi_updated_at: 'Updated {time}',
  global_kpi_sync_error: 'Could not sync the totals. Please try again.'
}
